module.exports = __webpack_public_path__ + "cc21a80dc0eef04588b96b5a6fdb343e.svg";